var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451,
    height: 379,
    viewBox: "0 0 451 379",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.375 378.114C228.377 378.116 228.376 378.119 228.374 378.119H223.215C222.826 378.119 222.444 378.013 222.111 377.812C221.063 377.18 220.021 376.543 218.959 375.936C148.61 335.655 78.2878 295.335 7.86504 255.196C2.0652 251.891 0.00675995 247.599 0.02017 241.171C0.134155 168.416 0.147565 95.6535 5.49357e-05 22.8913C-0.0133551 15.9932 2.42727 11.6945 8.4752 8.24881C78.3616 -31.5478 148.154 88.5012 217.893 48.4426C223.244 45.3731 227.736 45.3328 233.073 48.3889C302.826 88.434 372.625 -31.5948 442.511 8.20851C448.552 11.6475 451.033 15.9663 451 22.8644C450.805 60.8474 450.906 98.8305 450.906 136.814C450.906 171.908 450.845 207.01 450.959 242.105C450.98 248.022 448.881 252.173 443.571 254.954C437.764 257.997 432.159 261.409 426.473 264.666C360.443 302.481 294.406 340.296 228.376 378.11C228.374 378.111 228.374 378.113 228.375 378.114V378.114Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgsvg);
export default __webpack_public_path__ + "static/media/bgsvg.d4d1b51cc6622f4e7000ac2dc738c6fc.svg";
export { ForwardRef as ReactComponent };